import { styled } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { useEffect, useState } from "react";
import { ClipLoader } from "react-spinners";
import { Typography } from "@mui/material";
import styles from "../reportSection.module.scss";
import { formatAmount } from "../../common/StyledComponents/StyledFields";

const StyledTable = styled(Table)(({ theme }) => ({
  borderRadius: "8px",
  borderCollapse: "collapse", // Collapse borders to avoid doubled borders between cells
}));
const StyledTableContainer = styled(TableContainer)(({ theme }) => ({
  width: "100%",
  position: "relative",
  overflow: "auto",
  paddingBottom: "4px",
  borderRadius: "12px",
  "&::-webkit-scrollbar": {
    width: "8px",
    height: "8px",
    paddingTop: "10px",
    paddingRight: "10px",
  },
  "&::-webkit-scrollbar-thumb": {
    backgroundColor: "#F2BE22", // Scrollbar color
    borderRadius: "8px",
  },
  "&::-webkit-scrollbar-track": {
    backgroundColor: "transparent",
  },
  "&::-webkit-scrollbar-corner": {
    backgroundColor: "transparent",
  },
}));

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: " #FEBE00",
    fontWeight: "700",
    color: "#000",
    // writingMode: "horizontal-rl", // Vertical writing mode
    // textOrientation: "mixed", // Allows for upright text within vertical writing mode
    textAlign: "left",
    border: "1px solid #fff",
    padding: "10px",
    margin: "10px",

    // transform: "rotate(180deg)",
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    // whiteSpace: "pre-line",
    whiteSpace: "nowrap",
    textOrientation: "mixed", // Allows for upright text within vertical writing mode
    textAlign: "left",
    margin: 0,
    padding: "10px",
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  backgroundColor: theme.palette.action.hover,
  //   height: "-10px",
  "& td, & th": {
    margin: "10px",
    padding: "10px",
    border: "1px solid #fff",
  },
  "&:nth-of-type(even)": {
    backgroundColor: "#FFECB4", // Set odd rows to white
  },
  "&:nth-of-type(odd)": {
    backgroundColor: " #fff", // Set even rows to yellow
  },
}));

const PrintTreasuryReports = (props: any) => {
  const [tableHeaders, setTableHeaders] = useState<any>(props.tableHeaders)
  const [reportData, setReportData] = useState<any>(props.ReportData)
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setTableHeaders(props.tableHeaders);
    setReportData(props.ReportData);
  }, [props.tableHeaders, props.ReportData]);

  const colSpanLength = Object.values(props.tableHeaders).length || 0;

  const displayReportName = ()=>{
    switch(props.reportName){
      case "Drill Down Report" :
        return "DONATION / PUJA REPORT"  
      case "Donation Report" :
        return `Search Criteria and Amount :
         ${props?.formDataInfo?.searchCriteria !== '><' ? props?.formDataInfo?.searchCriteria +' '+ props?.formDataInfo?.amount : 
          '> '+ props?.formDataInfo?.amount +' and < '+ props?.formDataInfo?.amountUpperLimit 
         }`
      case "Revenue Reports":
        return `${props.requestBodyDrillDown.searchUserName ? `(${props.requestBodyDrillDown.searchUserName})` : ''}`; 
      case "Revenue Summary Report by Signin Name":
        return `${props.devoteeName.toUpperCase()}`
      default:
        break;
    }
}
const displayLabel = ()=>{
  switch(props.reportName){
    case 'Volunteers' :
      return 'Total no. of hours'
    default:
      return 'total'  
  }
}
const displayTotalAmount = ()=>{
  switch(props.reportName){
    case 'Volunteers' :
      return props.totalNumberofHours
    default:
      return formatAmount(props.totalDonatedAmount)   
  }
}
  return (
    <>
      {loading && (
          <div style={{ position: 'sticky', top: '50%', zIndex: '999', textAlign: 'center' }}>
            <ClipLoader color="#000" loading={loading} size={25} />
            <span
              style={{
                marginLeft: "8px",
                fontSize: "15px",
                textAlign: "center",
              }}
            >
            </span>
          </div>
      )}
      <Typography
        className={styles.typoGraphyHeader}
        style={{ textAlign: "center", margin: "10px 0",fontWeight:'bold' }}
      >
       {displayReportName()}
      </Typography>
      <StyledTableContainer sx={{ width: "100%" }}>
        <StyledTable aria-label="customized table">
          <TableHead>
            <TableRow>
              {Object.values(tableHeaders).map((header: any) => (header !== 'type' && 
                  <StyledTableCell align="center" key={header}>
                    <div style={{ textTransform: "capitalize", alignItems: "flex-start", verticalAlign: "top" }} dangerouslySetInnerHTML={{ __html: header }} />
                  </StyledTableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {reportData?.map((item: any, index: any) => (
              <StyledTableRow key={index} className={`${item.type === 'D' ? 'tableCellBlack' : item.type === 'P' ? 'tableCellBlue' : item.type === 'V' ? 'tableCellGreen' : null}`}>
                {Object.keys(tableHeaders).map((column) => (
                  column !== 'type' && 
                  <StyledTableCell key={column} className="tableCell">
                    <div style={{ textTransform: "capitalize", alignItems: "flex-start", verticalAlign: "top",
                    width:`${column === 'Description' && '200px'}`, 
                    whiteSpace:`${column === 'Description' && 'pre-wrap'}`,                     
                    overflowWrap:'break-word'}}
                    dangerouslySetInnerHTML={{ __html: item[column] }} />
                  </StyledTableCell>
                ))}
              </StyledTableRow>
            ))}
            {(props.reportName === 'Drill Down Report' || props.reportName === 'Revenue Reports' || props.reportName === 'Volunteers' || props.reportName === 'Vastra Report') && 
              <StyledTableRow style={{ backgroundColor: '#F2BE22' }}>
                <StyledTableCell>
                  <div style={{ textTransform: "capitalize", alignItems: "flex-start", verticalAlign: "top" }} dangerouslySetInnerHTML={{ __html: displayLabel() }} />
                </StyledTableCell>
                <StyledTableCell colSpan={colSpanLength - 1} style={{ textAlign: 'end' }}>
                  <div style={{ textTransform: "capitalize", alignItems: "flex-end", verticalAlign: "top" }} dangerouslySetInnerHTML={{ __html: displayTotalAmount() }} />
                </StyledTableCell>
              </StyledTableRow>}
          </TableBody>
        </StyledTable>
      </StyledTableContainer>
      {props.reportName === 'Pooja Booking Report' && 
      <>
       <div
              style={{
                backgroundColor: "#F2BE22",
                display: "flex",
                justifyContent: "space-between",
                padding: "5px",
                marginTop: "5px",
                border: "1px solid white",
              }}
            >
              <div
                style={{
                  textTransform: "capitalize",
                  alignItems: "flex-start",
                  verticalAlign: "top",
                }}
                dangerouslySetInnerHTML={{ __html: "Total Amount" }}
              />
              <div
                style={{
                  textTransform: "capitalize",
                  alignItems: "flex-start",
                  verticalAlign: "top",
                }}
                dangerouslySetInnerHTML={{
                  __html: formatAmount(props.totalAmounts_PoojaBooking.grandtotal),
                }}
              />
            </div>
            <div
              style={{
                backgroundColor: "#F2BE22",
                display: "flex",
                justifyContent: "space-between",
                padding: "5px",
                border: "1px solid white",
              }}
            >
              <div
                style={{
                  textTransform: "capitalize",
                  alignItems: "flex-start",
                  verticalAlign: "top",
                }}
                dangerouslySetInnerHTML={{ __html: "Total Refund" }}
              />
              <div
                style={{
                  textTransform: "capitalize",
                  alignItems: "flex-start",
                  verticalAlign: "top",
                }}
                dangerouslySetInnerHTML={{
                  __html: formatAmount(props.totalAmounts_PoojaBooking.refundamount),
                }}
              />
            </div>
            <div
              style={{
                backgroundColor: "#F2BE22",
                display: "flex",
                justifyContent: "space-between",
                padding: "5px",
                border: "1px solid white",
              }}
            >
              <div
                style={{
                  textTransform: "capitalize",
                  alignItems: "flex-start",
                  verticalAlign: "top",
                }}
                dangerouslySetInnerHTML={{ __html: "Total Amount" }}
              />
              <div
                style={{
                  textTransform: "capitalize",
                  alignItems: "flex-start",
                  verticalAlign: "top",
                }}
                dangerouslySetInnerHTML={{
                  __html: formatAmount(props.totalAmounts_PoojaBooking.remaining_after_refund),
                }}
              />
            </div>
      </>
      }
    </>
  );
};

export default PrintTreasuryReports;